import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcMylocation(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.219 3.787a8.25 8.25 0 0 0-7.435 7.463H6.5a.75.75 0 0 1 0 1.5H3.784a8.25 8.25 0 0 0 7.435 7.464V17.5a.75.75 0 1 1 1.5 0v2.72a8.25 8.25 0 0 0 7.497-7.47H17.5a.75.75 0 0 1 0-1.5h2.716a8.25 8.25 0 0 0-7.497-7.47v2.718a.75.75 0 0 1-1.5 0zM12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25",
    clipRule: "evenodd"
  }));
}
var IcMylocation = createNolIcon(/*#__PURE__*/forwardRef(SvgIcMylocation));

export { IcMylocation as I };
